var micActiveUploadsCounter = 0;

var totalMicUploadsCount = 0;
var callbackAfterMicUpload = null;

window.micObject = {
    'worker': null,
    'processor': null,
    'source': null,
    'isRecording': false
};

window.inProgressMicUploads = {};

function getDeviceSampleRate() {
    let sampleRate = 48000;

    var context = new (window.AudioContext || window.webkitAudioContext);
    return context.sampleRate || sampleRate;
}

function showMicCalibration() {
    if(window.save_on_server == "on" && window.record_audio_all == "on"){
        window.totalMicUploadsCount++;
    }
    displayText("title", trans("mic.Allow mic access"));

    askMicAccess(endMicCalibration, showFailedMicAccess);

    function showFailedMicAccess(e) {
        console.log('showFailedMicAccess');
        console.log(e);
        displayText("title", trans("mic.Mic is not available"));
    }

    function endMicCalibration(stream) {
        console.log('endMicCalibration');
        const calibrationTimeSeconds = 13;
        displayText("title", trans("mic.Calibration required"));
        //http://www.cs.columbia.edu/~hgs/audio/harvard.html
        // displayText("content", "<b>Read out loud these sentences:</b> <br>The birch canoe slid on the smooth planks.<br>It's easy to tell the depth of a well. <br>The juice of lemons makes fine punch.<br>Calibration will end in <span id='calibrationCountdown' style='min-width:23px; width:23px; display:inline-block; font-weight:bold;'>"+calibrationTimeSeconds+"</span> seconds");
        displayText("content", trans("mic.Read out loud these sentences") 
            + "<span id='calibrationCountdown' style='min-width:23px; width:23px; display:inline-block; font-weight:bold;'>"
            + calibrationTimeSeconds
            + "</span>"
            + trans("mic.seconds")
        );

        var calibrationTimeLeft = calibrationTimeSeconds;
        var calibrationTimer = setInterval(function(){
            calibrationTimeLeft--;
            document.getElementById("calibrationCountdown").textContent = calibrationTimeLeft;
            if(calibrationTimeLeft <= 0){
                clearInterval(calibrationTimer);
            }
        }, 1000);

        window.setTimeout(function() {
            // 15 seconds for calibration
            calibrateMic(stream, calibrationTimeSeconds * 1000, function(threshold) {
                console.log('calibration done with threshold ', threshold);
                // sound is to low
                if (threshold == 1) {
                    displayText("title",  trans("mic.We could not detect your voice"));
                    displayText("content", trans("mic.Please increase your mic volume"));
                    return;
                }

                window.micThreshold = threshold;

                displayText("title", trans("mic.Calibration completed"));
                displayText("content", trans("mic.The experiment will start shortly"));

                if (window.record_audio_all == 'on') {
                    recordAudioAllTrial(stream);
                } else {
                    // close mic
                    stream.getAudioTracks()[0].stop();
                }

                // start after 3s, just to have some time to read the message
                window.setTimeout(function() {
                    displayText("title", "");
                    displayText("content", "");
                    main();
                }, 3000);

            });

        }, 2000);
    }
}

function calibrateMic(stream, calibrationTime, onCalibrationDone) {

    console.log('calibrate mic');
    var context = new (window.AudioContext || window.webkitAudioContext);
    var source = context.createMediaStreamSource(stream);
    var processor = context.createScriptProcessor(4096*2*2, 1, 1);

    source.connect(processor);
    processor.connect(context.destination);

    var callibrationStartTime = 0;
    var minAverage = 1;
    var countChunks = 0;

    var totalAverage = 0;

    processor.onaudioprocess = function(e) {
    	countChunks++;
        if (!callibrationStartTime) {
            callibrationStartTime = performance.now();
        }

        const inputBuffer = e.inputBuffer;
        const inputData = inputBuffer.getChannelData(0);
        const voiceThreshold = 0.1;
        var countNonZero = 0;
        var sumNonZero = 0;
        var countZero = 0;
        var sumZero = 0;
        var chunkAverage = 0;


        inputData.forEach(function (s) {
            if (s > voiceThreshold) {
                countNonZero++;
                sumNonZero += s;
            }
            else {
                countZero++;
                sumZero += s;
            }
        });

        if (countNonZero > 0) {
            const average = sumNonZero / countNonZero;
            minAverage = Math.min(average, minAverage);
            console.log(average);
            chunkAverage += average;
        }

        if (countZero > 0){
            const chunkAverageSilence = sumZero / countZero;
            chunkAverage -= chunkAverageSilence;
        }

        chunkAverage *= 0.7;
        totalAverage += chunkAverage;

        if (performance.now() - callibrationStartTime > calibrationTime) {
            processor.onaudioprocess = null;
            context.close();

            totalAverage /= countChunks;
            console.log('countChunks', countChunks);
            console.log('prev threshold', minAverage);
            if (minAverage !== 1) {
                minAverage = Math.max(voiceThreshold, 0.9 * minAverage);
            }
            console.log('adjusted threshold', minAverage);
            console.log('current threshold', totalAverage);
            //Old threshold
            onCalibrationDone(minAverage);
            //Costi proposed threshold formula
            //onCalibrationDone(totalAverage);
        }
    };
}

// format: save or save:5000
function micResponseOptions(responseOptionsRaw) {
    responseOptionsRaw = responseOptionsRaw.toLowerCase();

    const options = {
        noHide: responseOptionsRaw.indexOf('nohide') >= 0,
        hideRec: responseOptionsRaw.indexOf('hiderec') >= 0,
        //default save duration: 1s
        duration: 1000
    };

    const saveRegex = /(save)(:([1-9][0-9]*))?/g;
    const saveMatches = saveRegex.exec(responseOptionsRaw);
    if(saveMatches !== null) {
        options.save = saveMatches[1] !== undefined,
        options.duration = parseInt(saveMatches[3]) || options.duration
    }

    return options;
}

function askMicAccess(onSuccess, onFailure) {
    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
        .then(onSuccess)
        .catch(onFailure);
}

function shouldCalibrateMic() {
     //can run this only once
    if (shouldCalibrateMic.hasRun) {
        return false;
    }

    shouldCalibrateMic.hasRun = true;

    return hasMicResponses();
}

function hasMicResponses() {
    if (window.record_audio_all == 'on') {
        return true;
    }

    const columnArr = columnArray('responseType');

    return columnArr.indexOf('mic') > -1;
}

function updateMicUploadProgress() {
    let totalProgress = 0;
    let n = 0;
    for (const [filename, progress] of Object.entries(window.inProgressMicUploads)) {
        n++;
        totalProgress += progress;
    }

    totalProgress = Math.round(totalProgress / n).toString();
    $("#uploadProgressBar").attr("value", totalProgress);
    $("#uploadProgressText").text(totalProgress + trans("mic.uploaded please wait"));
}

function uploadMicBlob(blob, fileName, trackProgress) {
    const postData = new FormData();
    postData.append('file', blob);
    postData.append('fileName', fileName);
    postData.append('startTimestamp', window.startTimestamp)
    window.micActiveUploadsCounter++;
    console.log('active uploads', micActiveUploadsCounter, fileName);

    var xhrBuilderWithProgress =  null;

    if(!window.inProgressMicUploads[fileName]) {
        window.inProgressMicUploads[fileName] = 0;
    }


    xhrBuilderWithProgress = function(){
        var xhr = $.ajaxSettings.xhr();
        //Set a progress event handler
        if(trackProgress){
            xhr.upload.onprogress = function(data){
                var percentage = Math.round((data.loaded / data.total) * 100);
                window.inProgressMicUploads[fileName] = percentage;
                updateMicUploadProgress();
            }
        }
        return xhr;
    }


    $.ajax({
        type: "POST",
        url: "serverSaveAudioTrial.php", //relative to current route user_id/project_id/
        data: postData,
        processData: false,
        contentType: false,
        complete: function() {
            console.log('uploading mic blob to server finished.');
            window.micActiveUploadsCounter--;
            console.log('active uploads', micActiveUploadsCounter);
            window.totalMicUploadsCount--;
            if (areAllMicUploadsDone() && window.callbackAfterMicUpload) {
                window.callbackAfterMicUpload();
            }
        },
        xhr: xhrBuilderWithProgress
    });

}

function recordAudioAllTrial(stream) {
    console.log('record all trial');

    const config = {
        encoderPath: "/assets/js/plugins/opus-recorder/encoderWorker.min.js"
    }

    const rec = new Recorder(config);

    const uploadData = function(blob, fileName){
        console.log('uploading to server...', blob, fileName);
        uploadMicBlob(blob, fileName, true);
    }

    const saveData = (function() {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        return function(blob, fileName) {
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        };
    }());


    rec.ondataavailable = function (typedArray){
        var dataBlob = new Blob( [typedArray], { type: 'audio/ogg' } );
        var fileName = "experiment" + ".opus";

        if(save_on_computer == "on"){
            console.log('save experiment recording locally');
            saveData(dataBlob, fileName);
        }

        if(save_on_server == "on"){
            showMicUploadProgressBar();
            uploadData(dataBlob, fileName);
        }
    }


    //rec.record();
    rec.start();

    if(save_on_server == "on"){
        window.onBeforeEndCallback = function(continueCallback) {
            window.onBeforeEndCallback = null;
            rec.stop();
            stream.getAudioTracks()[0].stop();
            // continueCallback == theEnd
            window.callbackAfterMicUpload = continueCallback;
        }
    }

    // save all recorded audio
    if (save_on_computer == "on" && save_on_server != "on") {
        testableOnEvent(window.events.experimentCompleted, function() {
            rec.stop();
            stream.getAudioTracks()[0].stop();
        });
    }
}

function showMicUploadProgressBar() {
    if(window.micProgressShowed) {
        return;
    }
    window.micProgressShowed = true;
    displayText("title", trans("mic.Uploading experiment recording"));
    const progressHTML = '<div id="uploadStatus" style="width: 70%; margin-left:15%"><h3 id="uploadProgressText"></h3><progress id="uploadProgressBar" value="0" max="100" style="width:70%;"></progress></div>';
    displayText("content", progressHTML);
    console.log('upload mic individual trials');
}

function currentResponseOptions() {
    return window.listTrialResponseOptions[window.trialRow];
}

function onResponseRecordingStarted(responseOptions) {
	console.log('[mic] onResponseRecordingStarted', JSON.stringify(responseOptions));
    // failsafe
    if (document.getElementById("responseMicCountdown") && !window.endRecordingMicResponse) {
    	console.log('[mic] onResponseRecordingStarted failsafe');
        return;
    }

    if(!responseOptions.noHide && !responseOptions.hideRec) {
        hideAll();
    }

    const responseDuration = responseOptions.duration / 1000;

    if (responseOptions.save) {
        window.totalMicUploadsCount++;
        const recTitle = trans('mic.recording-title');
        const recEnds = trans('mic.recording-ends');
        const seconds = trans('mic.seconds');
        $('#extraInfo').html(`
            <span style='color:red; font-size: 24px'>&#9679;</span> ${recTitle} <br> ${recEnds} 
            <span id='responseMicCountdown' style='min-width:23px; width:23px; display:inline-block; font-weight:bold;'>${responseDuration}</span> ${seconds}</div>
        `);
        $('#extraInfo').css('top', '50%');
        if(responseOptions.noHide) {
            $('#extraInfo').css('top', '5%');
        }
    } else {
        return;
    }

    var responseTimeLeft = responseDuration;
    var countdownDelay = performance.now();
    var responseTimer = setInterval(function() {

        responseTimeLeft--;

        console.log('delay until countdown start', performance.now() - countdownDelay);
        countdownDelay = performance.now();
        const countdownEl = document.getElementById("responseMicCountdown");
        if (countdownEl) {
            countdownEl.textContent = responseTimeLeft;
        }

        if (responseTimeLeft <= 0 || $('#extraInfo').html() === "") {
            clearInterval(responseTimer);
            $('#extraInfo').html("");
            $('#extraInfo').hide();
        }

    }, 1000);

    if(!responseOptions.hideRec) {
        $('#extraInfo').show();
    }
}

function enableMicResponse(onResponse) {
    if (window.inPreviewMode) {
        return;
    }

    console.log('[mic] enableMicResponse started');
    var timestampEnabledMicResponse = (new Date()).getTime();
    const responseOptions = currentResponseOptions();
    var t0;
    var myWorker = new Worker('/assets/js/audio_worker.js?2');
    myWorker.postMessage(['setSampleRate', getDeviceSampleRate()]);
    var streamGlobal;
    var source;
    var processor;
    const currentTrialRow = window.trialRow;
    const responseFileName = "row" + computeRowNo(window.trialRow) + ".wav";

    if (!window.onBeforeEndCallback) {
        window.onBeforeEndCallback = function(continueCallback) {
            window.onBeforeEndCallback = null;
            // waiting for upload to finish
            window.callbackAfterMicUpload = continueCallback;
        }
    }

    myWorker.onmessage = function(e) {        
        console.log('[mic] message received from worker', e.data);
        if (e.data.type == 'recordingStart') {
            window.micObject.isRecording = true;
            window.endRecordingMicResponse = function () {
                console.log('[mic] subito recording request');
                // trigger to stop recording
                // the result will be sent back via messages via a message from worker to main
                myWorker.postMessage('endRecording');
                $('#extraInfo').html("");
            };

            onResponseRecordingStarted(responseOptions);
            return;
        }

        // just to be sure we clear the old reference to myWorker so we keep things tidy
        delete window.endRecordingMicResponse;
        window.micObject.isRecording = false;

        try {
            myWorker.terminate();
            processor.disconnect();
            source.disconnect();
        } catch(e) {
            Bugsnag && Bugsnag.notify(e);
            console.error(e);
        }

        streamGlobal.getAudioTracks()[0].stop();

        var t1 = performance.now();
        console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.");
        console.log('sound detected');
        const response = 'mic';
        window.setTimeout(function() {
            onResponse(response, null, window.timeInMs + (e.data.startRecordingAt - timestampEnabledMicResponse));
        }, 0);

        const saveData = (function() {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            return function(blob, fileName) {
                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            };
        }());

        const uploadData = function(blob, fileName){
            console.log('uploading to server...', blob, fileName);
            uploadMicBlob(blob, fileName, true);
        }

        console.log('[mic] responseOptions', responseOptions);
        console.log('[mic] save_on_computer', save_on_computer);
        // save only if response options says so
        if (responseOptions.save) {

            if (save_on_computer == "on") {
                saveData(e.data.blob, responseFileName);
            }

            if(save_on_server == "on"){
                uploadData(e.data.blob, responseFileName);
            }
        }

    }

    var handleSuccess = function(stream) {
        streamGlobal = stream;
        var context = new (window.AudioContext || window.webkitAudioContext);
        // closure variables
        source = context.createMediaStreamSource(stream);
        processor = context.createScriptProcessor(256, 1, 1);

        source.connect(processor);
        processor.connect(context.destination);

        processor.onaudioprocess = function(e) {
            t0 = performance.now();
            const inputBuffer = e.inputBuffer;
            const inputData = inputBuffer.getChannelData(0);
            myWorker.postMessage([inputData, responseOptions.duration, window.micThreshold]);
        };

        micObject.source = source;
        micObject.processor = processor;
    };

    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
        .then(handleSuccess);

    micObject.myWorker = myWorker;
}

function areAllMicUploadsDone(){
    return (window.totalMicUploadsCount <= 0 && window.micActiveUploadsCounter == 0) || save_on_server == "na";
}

function clearMic() {
    if(window.micObject.isRecording) {
        return;
    }

    window.micObject.worker && window.micObject.worker.terminate();
    window.micObject.processor && window.micObject.processor.disconnect();
    window.micObject.source && window.micObject.source.disconnect();
}